import React from "react";
import type { IconSize, IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { StyledDropdownEmptyItem } from "./styles";

type DropdownEmptyItemProps = {
    text: string;
    iconName?: IconName;
    iconSize?: IconSize;
};

const DropdownEmptyItem = (props: DropdownEmptyItemProps) => {
    const { text, iconName = "no-search-results", iconSize = "sm" } = props;

    return (
        <StyledDropdownEmptyItem>
            <SWReactIcons
                iconName={iconName}
                size={iconSize}
            />
            <span>{text}</span>
        </StyledDropdownEmptyItem>
    );
};

export default React.memo(DropdownEmptyItem);
